export default "__VITE_ASSET__C6O9C4Mm__"